import _ from 'lodash';
import { StyledCell } from '../Row.style';
import MultipleAvatars from 'components/MultipleAvatars';
import { ICON_SIZES } from 'common/constants/sizes';

const MAX_AVATARS = 4;

const AssigneesCell = ({ assignees = {} }) => {
  const topAssignees = _.get(assignees, 'top_assignees', []).slice(
    0,
    MAX_AVATARS
  );
  const totalAssignees = _.get(assignees, 'total');

  const diff = totalAssignees - topAssignees.length;
  const diffArr = diff > 0 ? _.fill(Array(diff), {}) : [];
  const avatars = topAssignees.map(assignee => ({
    url: _.get(assignee, 'assignee_avatar_url', ''),
    name: assignee?.assignee_name
  }));
  const filledAvatars = [...avatars, ...diffArr];

  return (
    <StyledCell>
      <MultipleAvatars
        disableTooltipForRest={true}
        avatars={filledAvatars}
        limit={MAX_AVATARS}
        size={ICON_SIZES['x-medium']}
      />
    </StyledCell>
  );
};

export default AssigneesCell;
